module.exports = "<button class=\"{{$ctrl.btnClass}}\" ng-click=\"$ctrl.onClick($event)\">\n    <i class=\"{{$ctrl.btnStartIcon}}\" ng-if=\"$ctrl.btnStartIcon\"></i>\n    {{$ctrl.text}}\n    <i class=\"{{$ctrl.btnEndIcon}}\" ng-if=\"$ctrl.btnEndIcon\"></i>\n</button>"


//////////////////
// WEBPACK FOOTER
// ./~/@front10/healthcare-book/src/app/common/button/button.html
// module id = 581
// module chunks = 0